import TextAndImageWidget from './TextAndImageWidget';

function textAndImageWidget (widgetConfigs) {
    let {container, elementOptions, ...widgetParams} = widgetConfigs;

    return TextAndImageWidget.create(
        container,
        {
            cssClasses: 'd-flex is-search-widget is-search-widget--text-image',
            itemCssClasses: 'mx-2 justify-content-between',
            selectedCssClasses: 'border-primary',
            imageCssClasses: 'image',
            textCssClasses: 'text d-flex align-items-end',
            ...elementOptions
        },
        widgetParams
    );
}

export default textAndImageWidget;

